export default "__VITE_ASSET__BQX$ruAR__"